export const mockIncidencesTracking = [
  {
    id: 76510,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81372',
    duration: '0 d 17 h 2 m 0 s',
    downtime: 'exclude',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'SG340',
    rootCause: 'Voluntary shutoff',
    resolution: 'Unknown',
    startTime: '2025-06-25T15:13:52.000Z',
    endTime: '2025-06-25T15:15:52.000Z',
  },
  {
    id: 76509,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81371',
    duration: '0 d 15 h 23 m 0 s',
    downtime: 'include',
    notes: null,
    createdBy: 'reesha A',
    updatedBy: null,
    listingTitle: 'L7716',
    rootCause: 'Building Network Outage (Wifi)',
    resolution: 'Waited for Area Network Recover',
    startTime: '2025-06-11T20:00:59.000Z',
    endTime: '2025-06-11T20:00:59.000Z',
  },
  {
    id: 63491,
    category: 'uptime',
    externalReference: null,
    zendeskId: null,
    duration: '0 d 22 h 9 m 12 s',
    downtime: 'include',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'L7728',
    rootCause: 'Voluntary shutoff',
    resolution: 'Unknown',
    startTime: '2025-01-31T19:50:20.000Z',
    endTime: '2025-01-31T19:50:20.000Z',
  },
  {
    id: 63468,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81370',
    duration: '1 d 3 h 20 m 1 s',
    downtime: 'include',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'SG340',
    rootCause: 'Breaker Tripped',
    resolution: 'Reset Breaker',
    startTime: '2025-01-31T19:40:52.000Z',
    endTime: '2025-01-31T19:40:52.000Z',
  },
  {
    id: 63437,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81369',
    duration: '0 d 14 h 0 m 3 s',
    downtime: 'include',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'L6654',
    rootCause: 'Area Power Outage',
    resolution: 'Waited for Area Network Recover',
    startTime: '2025-01-31T19:15:38.000Z',
    endTime: '2025-01-31T19:15:38.000Z',
  },
  {
    id: 63080,
    category: 'uptime',
    externalReference: null,
    zendeskId: null,
    duration: '0 d 2 h 6 m 0 s',
    downtime: 'include',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'SG340',
    rootCause: 'Voluntary shutoff',
    resolution: 'Unknown',
    startTime: '2025-01-29T15:35:46.000Z',
    endTime: '2025-01-29T17:41:46.000Z',
  },
  {
    id: 56201,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81367',
    duration: '9 d 22 h 54 m 0 s',
    downtime: 'include',
    notes: null,
    createdBy: 'SWTCH S',
    updatedBy: null,
    listingTitle: 'L7725',
    rootCause: 'Communication Network Outages',
    resolution: 'Replaced SWTCH Network Hardware',
    startTime: '2024-12-09T17:34:12.000Z',
    endTime: '2024-12-19T16:28:12.000Z',
  },
  {
    id: 32248,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81366',
    duration: '4 d 23 h 12 m 0 s',
    downtime: 'exclude',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: 'Reesha M',
    listingTitle: 'SG340',
    rootCause: 'Voluntary shutoff',
    resolution: 'Unknown',
    startTime: '2024-08-30T15:24:00.000Z',
    endTime: '2024-08-30T15:25:00.000Z',
  },
  {
    id: 32241,
    category: 'uptime',
    externalReference: null,
    zendeskId: '81365',
    duration: '3 d 22 h 2 m 0 s',
    downtime: 'exclude',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'SG340',
    rootCause: 'Voluntary shutoff',
    resolution: 'Unknown',
    startTime: '2024-08-30T15:13:52.000Z',
    endTime: '2024-08-30T15:15:52.000Z',
  },
  {
    id: 32242,
    category: 'uptime',
    externalReference: null,
    zendeskId: null,
    duration: '0 d 15 h 2 m 12 s',
    downtime: 'exclude',
    notes: null,
    createdBy: 'Reesha M',
    updatedBy: null,
    listingTitle: 'L6652',
    rootCause: 'Voluntary shutoff',
    resolution: 'Unknown',
    startTime: '2024-08-30T15:13:52.000Z',
    endTime: '2024-08-30T15:15:52.000Z',
  },
]

export const mockIncidencesResponse = {
  data: mockIncidencesTracking,
  pagination: {
    currentPage: 1,
    totalEntries: mockIncidencesTracking.length,
    perPage: 20,
  },
}

export const mockIncidenceUpdateResponse = {
  id: 26,
  category: 'uptime',
  externalReference: 'MyString',
  zendeskId: 'Zen-123',
  duration: '2 d 0 h 0 m 0 s',
  downtime: 'include',
  notes: undefined,
  createdBy: undefined,
  updatedBy: undefined,
  listingTitle: 'Listing 1',
  rootCause: 'Low Voltag',
  startTime: '2024-08-06T20:13:41.000Z',
}
